import { render, staticRenderFns } from "./OnboardingIntegrationSettingsContent.vue?vue&type=template&id=4a5bd7e2&scoped=true&lang=pug"
import script from "./OnboardingIntegrationSettingsContent.vue?vue&type=script&lang=ts"
export * from "./OnboardingIntegrationSettingsContent.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingIntegrationSettingsContent.vue?vue&type=style&index=0&id=4a5bd7e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5bd7e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VContainer,VForm,VIcon,VRow,VTextField,VTooltip})
